module.exports = __webpack_public_path__ + "img/Outpost24.17afc00f.png";